/**
 * Clerk inbound presenter — declarative metadata consumed by the
 * shared inbound toolkit (trigger provisioning, settings editor,
 * webhook URL display, connection minting).
 */
import type { InboundProviderPresenter } from '@/lib/integrations/inbound/types'

import {
  CLERK_EVENT_CATEGORIES,
  CLERK_EVENT_METADATA,
} from './supported-events'

export const CLERK_SIGNING_SECRET_PREFIX = 'whsec_'
export const CLERK_SIGNING_SECRET_MIN_LENGTH = 24

export const clerkInboundPresenter: InboundProviderPresenter = {
  providerId: 'clerk',
  displayName: 'Clerk',
  signingSecretPrefix: CLERK_SIGNING_SECRET_PREFIX,
  categories: CLERK_EVENT_CATEGORIES,
  events: CLERK_EVENT_METADATA,
  defaultTriggerLoop: true,
  triggerEventId({ orgId, brandId, eventType }) {
    return `clerk:${orgId}:${brandId}:${eventType}`
  },
}
